import React from 'react';
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Row, Col, Button } from "reactstrap";
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { BiSave } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { AiOutlineHome } from "react-icons/ai";
import { useCookies } from 'react-cookie';
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { moment } from 'moment';
import { useLocation, Link,useParams } from 'react-router-dom';
import {displayErrorToast,displayError} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import { updateMoisture,getMoistureDetails, getMoistureDailyCount, getMcNumber, printMoistureCorrection } from "../../services/MoistureCorrectionServices";
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import {getUserAllowedPlants} from '../../services/PlantServices'
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { confirmMoistureSoftLimit, formatMoistureDailyCount } from '../../utils/moistureCorrectionUtils';
import { getCurrentDate, getCurrentTime } from '../../utils/DateUtils';
import { openPdfResponse } from '../../utils/openPdfInApp';
function MoistureCorrectionEdit() {
  const [category] = useCookies(['myCategory']);
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [superuser] = useCookies(['mySuperuser']);
  const [plants, setPlants] = useState([]);
  const [cookies] = useCookies(['myToken']);
  const [inProgress, setInProgress] = useState(false);
  const [inputs, setInputs] = useState({});
  const [rowsData, setRowsData] = useState([]);
  const [dailyCountMeta, setDailyCountMeta] = useState(null);
  const [canUpdateInPlace, setCanUpdateInPlace] = useState(false);
  const originalMoistureRef = React.useRef(null);

  const navigate = useNavigate();
  const handleChange = (event) => {
  const name = event.target.name;
  const value = event.target.value;
 try{
      if(name === 'moisture_msand') 
      {
          var cf_msand = ((value) - (inputs.absorption_msand)).toFixed(2);
          console.log(cf_msand+inputs.absorption_msand+value+"cf_msandmois")
          setInputs(values => ({ ...values, ['correction_factor_msand']: cf_msand }))
      } 
      else if(name === 'absorption_msand') 
      {
          var cf_msand = ((inputs.moisture_msand) - (value)).toFixed(2);
          console.log(cf_msand+"cf_msandabbbb")
          setInputs(values => ({ ...values, ['correction_factor_msand']: cf_msand }))
      }  
      else if(name === 'moisture_csand') 
      {
          var cf_csand = ((value) - (inputs.absorption_csand)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_csand']: cf_csand }))
      } 
      else if(name === 'absorption_csand') 
      {
          var cf_csand = ((inputs.moisture_csand) - (value)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_csand']: cf_csand }))
      }  
      else if(name === 'moisture_rsand') 
      {
          var cf_rsand = ((value) - (inputs.absorption_rsand)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_rsand']: cf_rsand }))
      } 
      else if(name === 'absorption_rsand') 
      {
          var cf_rsand = ((inputs.moisture_rsand) - (value)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_rsand']: cf_rsand }))
      }  
      else if(name === 'moisture_12mm') 
      {
          var cf_12mm = ((value) - (inputs.absorption_12mm)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_12mm']: cf_12mm }))
      } 
      else if(name === 'absorption_12mm') 
      {
          var cf_12mm = ((inputs.moisture_12mm) - (value)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_12mm']: cf_12mm }))
      }  
      else if(name === 'moisture_20mm') 
      {
          var cf_20mm = ((value) - (inputs.absorption_20mm)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_20mm']: cf_20mm }))
      } 
      else if(name === 'absorption_20mm') 
      {
          var cf_20mm = ((inputs.moisture_20mm) - (value)).toFixed(2);
          setInputs(values => ({ ...values, ['correction_factor_20mm']: cf_20mm }))
      }
      else if (name === 'mc_date' || name === 'mc_time') {
          const updated = { ...inputs, [name]: value };
          setInputs(updated);
          if (updated.plant_id) {
            getMcNumber(cookies, parseInt(updated.plant_id, 10), updated.mc_date, updated.mc_time)
              .then((meta) => setInputs((prev) => ({ ...prev, mc_no: meta.mc_no, mc_date: meta.mc_date, mc_time: (meta.mc_time || '').slice(0, 5) })))
              .catch(() => {});
          }
          return;
      }
      setInputs(values => ({ ...values, [name]: event.target.value }))
    }
  catch(e)
  {
    displayErrorToast(e);
  } 
}

const buildMoisturePayload = () => ({
  id: inputs.id,
  plant: parseInt(inputs.plant_id, 10),
  mc_date: inputs.mc_date,
  mc_time: inputs.mc_time,
  moisture_msand: inputs.moisture_msand ? parseFloat(inputs.moisture_msand) : 0,
  moisture_csand: inputs.moisture_csand ? parseFloat(inputs.moisture_csand) : 0,
  moisture_rsand: inputs.moisture_rsand ? parseFloat(inputs.moisture_rsand) : 0,
  moisture_12mm: inputs.moisture_12mm ? parseFloat(inputs.moisture_12mm) : 0,
  moisture_20mm: inputs.moisture_20mm ? parseFloat(inputs.moisture_20mm) : 0,
  absorption_msand: inputs.absorption_msand ? parseFloat(inputs.absorption_msand) : 0,
  absorption_csand: inputs.absorption_csand ? parseFloat(inputs.absorption_csand) : 0,
  absorption_rsand: inputs.absorption_rsand ? parseFloat(inputs.absorption_rsand) : 0,
  absorption_12mm: inputs.absorption_12mm ? parseFloat(inputs.absorption_12mm) : 0,
  absorption_20mm: inputs.absorption_20mm ? parseFloat(inputs.absorption_20mm) : 0,
  correction_factor_msand: parseFloat(inputs.correction_factor_msand),
  correction_factor_csand: parseFloat(inputs.correction_factor_csand),
  correction_factor_rsand: parseFloat(inputs.correction_factor_rsand),
  correction_factor_12mm: parseFloat(inputs.correction_factor_12mm),
  correction_factor_20mm: parseFloat(inputs.correction_factor_20mm),
  is_active: inputs.is_active !== false,
});

const isStatusOnlyChange = () => {
  if (!originalMoistureRef.current) {
    return false;
  }
  const original = originalMoistureRef.current;
  const moistureFields = [
    'moisture_msand', 'moisture_csand', 'moisture_rsand', 'moisture_12mm', 'moisture_20mm',
    'absorption_msand', 'absorption_csand', 'absorption_rsand', 'absorption_12mm', 'absorption_20mm',
  ];
  const valuesChanged = moistureFields.some((field) => (
    parseFloat(inputs[field] || 0) !== parseFloat(original[field] || 0)
  ));
  const dateChanged = (inputs.mc_date || '') !== (original.mc_date || '');
  const timeChanged = (inputs.mc_time || '').slice(0, 5) !== (original.mc_time || '').slice(0, 5);
  const statusChanged = (inputs.is_active !== false) !== (original.is_active !== false);
  return statusChanged && !valuesChanged && !dateChanged && !timeChanged;
};

const saveMoistureCorrection = () => {
  updateMoisture(cookies, buildMoisturePayload(), id)
    .then((response) => {
      const updatedInPlace = response?.updated_in_place ?? canUpdateInPlace;
      const saveMode = response?.save_mode;
      let message = 'New moisture correction recorded.';
      if (saveMode === 'status_update') {
        message = `Status updated to ${inputs.is_active === false ? 'Inactive' : 'Active'}.`;
      } else if (updatedInPlace) {
        message = `Moisture correction ${inputs.mc_no || ''} updated.`;
      }
      Swal.fire('Saved!', message, 'success');
      view();
    })
    .catch((error) => {
      displayError(error.response?.data, 'Save Failed');
    });
};

const handleSubmit=async (event)=> {
    event.preventDefault();
    try{
      console.log(JSON.stringify(inputs)+"inputs");
       
              if ((Object.values(error).every(x => !x)) && isSubmitting) {
                      if (canUpdateInPlace) {
                        Swal.fire({
                          title: 'Update this moisture correction?',
                          html: `Values will be updated on <b>${inputs.mc_no || 'this MC'}</b>.<br/>No delivery challan is linked yet.`,
                          showCancelButton: true,
                          confirmButtonText: 'Yes, update',
                          cancelButtonText: 'No',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            saveMoistureCorrection();
                          } else if (result.isDismissed) {
                            Swal.fire('Not saved', '', 'info');
                          }
                        });
                        return;
                      }

                      if (isStatusOnlyChange()) {
                        Swal.fire({
                          title: inputs.is_active === false ? 'Deactivate this MC?' : 'Activate this MC?',
                          html: inputs.is_active === false
                            ? 'This MC will no longer appear for new delivery challans. Linked DCs keep their existing batch report.'
                            : 'This MC will be available for delivery challan selection.',
                          showCancelButton: true,
                          confirmButtonText: 'Yes, update status',
                          cancelButtonText: 'No',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            saveMoistureCorrection();
                          } else if (result.isDismissed) {
                            Swal.fire('Not saved', '', 'info');
                          }
                        });
                        return;
                      }

                      const canProceed = await confirmMoistureSoftLimit(
                        cookies,
                        parseInt(inputs.plant_id, 10),
                        'save a new correction'
                      );
                      if (!canProceed) {
                        return;
                      }
                      Swal.fire({title: 'Save as new correction?',  
                      html: 'This MC is already linked to delivery challan(s). A new moisture correction record will be created. Previous values are kept in history.',
                      showCancelButton: true,  
                      confirmButtonText: `Yes`,  
                      cancelButtonText: `No`,
                      }).then((result) => {  
                        if (result.isConfirmed) { 
                          saveMoistureCorrection();
                      } 
                      else if (result.isDismissed) 
                      {    
                        Swal.fire('Not saved', '', 'info')  
                      }
                    });
              }
              else
              {
                Swal.fire('Please check * marked fields are filled and details given are valid...', '', 'info')   
              }
           }
            catch(e)
            {
              displayErrorToast(e);
            }
         } 

  const Cancel = () => {
    setInputs(() => "")
    setRowsData([])
  }
  const Reload = () => {
    window.location.reload();
  } 
  const view = () => {
    navigate('/MoistureCorrectionTable')
  } 

  const Back = () => {
    navigate('/Home')
  }

  const onPrintMoistureCorrection = async () => {
    try {
      const blob = await printMoistureCorrection(cookies, id);
      openPdfResponse(blob, {
        title: 'Moisture Correction Report',
        downloadFileName: `moisture_correction_${id}.pdf`,
      });
    } catch (error) {
      let message = error?.response?.data ?? error.message;
      if (message instanceof Blob) {
        try {
          const text = await message.text();
          message = JSON.parse(text);
        } catch {
          message = 'PDF generation failed on server.';
        }
      }
      displayError(message, 'Print Failed');
    }
  };

  const {id}=useParams()
  React.useEffect(() => {
    if (id) {
      setInProgress(true);
      Promise.all([
        getUserAllowedPlants(cookies),
        getMoistureDetails(cookies, id)
      ])
        .then(([plantRes, moistureRes]) => {
          const plantOptions = plantRes.plant_list
          .filter(p => p.status == true)
          .map(p=> ({
            value: p.id,
            label: p.plant_alias
          }));
          setPlants(plantOptions);
          setInProgress(false);
          const linkedDcCount = Number(
            moistureRes.delivery_challan_count ?? moistureRes.delivery_challans?.length ?? 0
          );
          const updateInPlace = moistureRes.can_update_in_place ?? linkedDcCount === 0;
          setCanUpdateInPlace(updateInPlace);
          const loadedInputs = {
            ...moistureRes,
            plant_id: moistureRes.plant_id? String(moistureRes.plant_id) : "",
            mc_no: moistureRes.mc_no || '',
            mc_date: moistureRes.mc_date || getCurrentDate(),
            mc_time: (moistureRes.mc_time || getCurrentTime()).slice(0, 5),
            is_active: moistureRes.is_active !== false,
            moisture_msand:moistureRes.moisture.msand,
            moisture_csand:moistureRes.moisture.csand,
            moisture_rsand:moistureRes.moisture.rsand,
            absorption_msand:moistureRes.absorption.msand,
            absorption_csand:moistureRes.absorption.csand,
            absorption_rsand:moistureRes.absorption.rsand,
            moisture_12mm:moistureRes.moisture['12mm'],
            moisture_20mm:moistureRes.moisture['20mm'],
            absorption_12mm:moistureRes.absorption['12mm'],
            absorption_20mm:moistureRes.absorption['20mm'],
            correction_factor_msand:moistureRes.correction_factor.msand,
            correction_factor_csand:moistureRes.correction_factor.csand,
            correction_factor_rsand:moistureRes.correction_factor.rsand,
            correction_factor_12mm:moistureRes.correction_factor['12mm'],
            correction_factor_20mm:moistureRes.correction_factor['20mm'],
          };
          originalMoistureRef.current = loadedInputs;
          setInputs(loadedInputs);
            console.log("Plant ID from API:", moistureRes.plant_id?.id);
            console.log("Plants List:", plantOptions);
            console.log("Full Moisture Response:", moistureRes);
          if (moistureRes.plant_id) {
            getMoistureDailyCount(cookies, moistureRes.plant_id)
              .then(setDailyCountMeta)
              .catch(() => setDailyCountMeta(null));
          }
          //console.log(JSON.stringify(setInputs)+"setInputs")
        })
        .catch(error => {
          setInProgress(false);
          displayError(error.response.data, "Loading Failed");
          console.log(error+"error")
        });
      }
    }, [id]);

return(
    <>
    <div id="outer-container" className="App" >
    <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
    <ErrorToast/>
    <LoadingOverlay inProgress={inProgress}/>
    <div id="page-wrap">
    <form onSubmit={handleSubmit} >
      <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="QUALITY CONTROL"
                title={canUpdateInPlace ? 'Edit Moisture Correction' : 'Moisture Correction'}
                subtitle={canUpdateInPlace
                  ? 'No delivery challan is linked yet. Saving updates this MC number in place.'
                  : 'Linked to delivery challan(s). Change status only, or save new values as a new MC record.'}
                modeLabel={canUpdateInPlace ? 'EDIT MODE' : 'NEW VERSION'}
              />
              {!canUpdateInPlace && dailyCountMeta && (
                <p className="text-center mb-0" style={{ color: dailyCountMeta.soft_limit_reached ? '#b45309' : '#1e40af', fontWeight: 600 }}>
                  {formatMoistureDailyCount(dailyCountMeta)}
                  {dailyCountMeta.soft_limit_reached ? ' — additional saves allowed with confirmation' : ''}
                </p>
              )}
            </div>
      <FloatingControls tableLink="/MoistureCorrectionTable" enableCancel={false} enablePrint onPrint={onPrintMoistureCorrection} />
        <div className="container">
          <Row>
                <Col xl={12} lg={12} md={12}>
                    <div className="form-row table-bordered shadow p-2 my-1 border-secondary p-3 mb-2 bg-blue form-control-panel" >
                          <div className="moisture-correction-meta">
                            <div className="moisture-correction-meta-left">
                              <div className="moisture-correction-meta-item mc-meta-plant">
                                <label>Plant</label>
                                <input
                                  className="form-control"
                                  value={inputs.plant_name || ""}
                                  readOnly
                                  style={{ cursor: 'not-allowed' }}
                                />
                              </div>
                              <div className="moisture-correction-meta-item mc-meta-mcno">
                                <label>MC No.</label>
                                <input type="text" className="form-control" value={inputs.mc_no || ''} readOnly style={{ cursor: 'not-allowed' }} />
                              </div>
                              <div className="moisture-correction-meta-item mc-meta-date">
                                <label htmlFor="mc_date">Date</label>
                                <input type="date" id="mc_date" name="mc_date" className="form-control mandatory-form-control" value={inputs.mc_date || ''} onChange={handleChange} required />
                              </div>
                              <div className="moisture-correction-meta-item mc-meta-time">
                                <label htmlFor="mc_time">Time</label>
                                <input type="time" id="mc_time" name="mc_time" className="form-control mandatory-form-control" value={inputs.mc_time || ''} onChange={handleChange} required />
                              </div>
                            </div>
                            <div className="moisture-correction-meta-item mc-meta-status">
                              <label htmlFor="is_active">Status</label>
                              <select
                                id="is_active"
                                name="is_active"
                                className="form-control mandatory-form-control"
                                value={inputs.is_active === false ? 'false' : 'true'}
                                onChange={(e) => setInputs({ ...inputs, is_active: e.target.value === 'true' })}
                              >
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                            </div>
                          </div>

                          <div className="w-100 mb-3"></div>   {/* <<< adds space */}

                          <span className="col-sm-1"></span>
                          <h5 className="col-sm-3 text-center"><b>Moisture (%)</b></h5>
                          <span className="col-sm-1"></span>
                          <h5 className="col-sm-3 text-center"><b>Absorption (%)</b></h5>
                          <span className="col-sm-1"></span>
                          <h5 className="col-sm-3 text-center"><b>Correction Factor (%)</b></h5>                        

                          <label htmlFor="moisture_msand" className="form-group col-sm-1 text-right">MSAND </label>
                          <input type="number"  step="any" id="moisture_msand" onChange={handleChange} value={inputs.moisture_msand || 0} name="moisture_msand" max="15"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="absorption_msand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number"  step="any"id="absorption_msand" onChange={handleChange} value={inputs.absorption_msand || 0} name="absorption_msand" max="5" min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="correction_factor_msand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number" id="correction_factor_msand"  value={inputs.correction_factor_msand || 0} name="correction_factor_msand" className="form-control col-sm-3" readOnly={true} style={{cursor: "not-allowed"}}   pattern="[0-9]*" required/><br/><br/>

                          <label htmlFor="moisture_csand" className="form-group col-sm-1 text-right">CSAND </label>
                          <input type="number"  step="any"id="moisture_csand" onChange={handleChange} value={inputs.moisture_csand || 0} name="moisture_csand" max="15"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="absorption_csand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number" step="any" id="absorption_csand" onChange={handleChange} value={inputs.absorption_csand || 0} name="absorption_csand" max="5" min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="correction_factor_csand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number" id="correction_factor_csand"  value={inputs.correction_factor_csand || 0} name="correction_factor_csand" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>

                          <label htmlFor="moisture_rsand" className="form-group col-sm-1 text-right">RSAND </label>
                          <input type="number"  step="any"id="moisture_rsand" onChange={handleChange} value={inputs.moisture_rsand || 0} name="moisture_rsand" max="15"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>  
                          <label htmlFor="absorption_rsand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number"  step="any"id="absorption_rsand" onChange={handleChange} value={inputs.absorption_rsand || 0} name="absorption_rsand" max="5" min="0"  className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/> 
                          <label htmlFor="correction_factor_rsand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number" id="correction_factor_rsand"  value={inputs.correction_factor_rsand || 0} name="correction_factor_rsand" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>

                          <label htmlFor="moisture_12mm" className="form-group col-sm-1 text-right">12 MM </label>
                          <input type="number"  step="any"id="moisture_12mm" onChange={handleChange} value={inputs.moisture_12mm || 0} name="moisture_12mm" max="15"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="absorption_12mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number"  step="any"id="absorption_12mm" onChange={handleChange} value={inputs.absorption_12mm || 0} name="absorption_12mm"  max="5" min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="correction_factor_12mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number" id="correction_factor_12mm"  value={inputs.correction_factor_12mm || 0} name="correction_factor_12mm" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>

                          <label htmlFor="moisture_20mm" className="form-group col-sm-1 text-right">20 MM </label>
                          <input type="number" step="any" id="moisture_20mm" onChange={handleChange} value={inputs.moisture_20mm || 0} name="moisture_20mm" max="15"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="absorption_20mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number"  step="any" id="absorption_20mm" onChange={handleChange} value={inputs.absorption_20mm || 0} name="absorption_20mm" max="5" min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                          <label htmlFor="correction_factor_20mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                          <input type="number" id="correction_factor_20mm"  value={inputs.correction_factor_20mm || 0} name="correction_factor_20mm" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>
                    </div>
                    </Col>
                </Row>
                </div>

                <div className="footer text-center">
                  <Button  type="submit" className="btn btn-twitter" style={{width:"120px",fontWeight:"bold"}} >
                    {canUpdateInPlace ? 'Update' : 'Save New'}
                  </Button> &nbsp;&nbsp;
                  <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={view}>View</Button>&nbsp;&nbsp;
                  <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={Back}>Home</Button>
                </div>
        </form>
    </div>
    </div>
    </>
    );
}
export default MoistureCorrectionEdit;